import * as React from 'react';
import S from './FlowchartCard.styles';
const FlowchartCard = (props) => {
    return (React.createElement(S.Container, { "data-bg-colour": props.bgColour ?? 'dark', "data-theme": props.typeTheme ?? 'default', "data-alignment": props.alignment ?? 'left' },
        React.createElement(S.ContentWrapper, null,
            props.iteration && (React.createElement(S.Count, null, props.stepText ? props.stepText : 'Step ' + props.iteration)),
            React.createElement(S.ContentArea, null,
                props.title && React.createElement(S.Heading, null, props.title),
                props.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: props.description } }))))));
};
export default FlowchartCard;
